var swiper = new Swiper(".product-col-slider", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    1400: {
      slidesPerView: 5.3,
      spaceBetween: 20
    },
    1200: {
      slidesPerView: 4.3,
      spaceBetween: 20
    },
    990: {
      slidesPerView: 3.3,
      spaceBetween: 20
    },
    0: {
      slidesPerView: 2.3,
      spaceBetween: 20
    },
  }
});


var swiper = new Swiper(".custom-col-sliders", {
  pagination: {
    el: ".swiper-pagination",
  },
});